import { withInstall } from '../utils'
import _TextareaAuto from './TextareaAuto'
import './index.scss'

export const TextareaAuto = withInstall(_TextareaAuto)
export default TextareaAuto
